import { useHistory, useParams } from 'react-router-dom';
import PublicLayout from '../../components/Common/PublicLayout';
import storage from '../../lib/storage';
import LoginContainer from './LoginContainer';
import LoginWithInfoAside from './LoginWithInfoAside';

const Login = () => {
  const { lang } = useParams<{ lang?: string; showOnlySelected?: string }>();
  const detectedLang = lang || storage.getDetectedLanguage()?.substring(0, 2);
  const history = useHistory();

  return (
    <PublicLayout basePath={'login'} history={history} lang={detectedLang} aside={<LoginWithInfoAside />}>
      <LoginContainer />
    </PublicLayout>
  );
};

export default Login;
